import { defineComponent, reactive, SetupContext } from '@vue/composition-api';
import MessageConst from '@/shared/message-const';
import CommonFunction from '@/shared/common-function';

// リアクティブな変数の型定義
export type reactiveData = {
    displayMessage: string;
}

/**
 * 404エラー画面コンポーネント
 *
 * 存在しないURLが指定された場合に表示する
 */
export default defineComponent({
    setup(props, ctx: SetupContext) {
        const state: reactiveData = reactive<reactiveData>({
            displayMessage: ''
        })

        /**
         * created ライフサイクルフック
         *
         * 指定されたページが見つからない旨のメッセージを設定する
         */
        created();
        async function created() {
            // titleIcon変更（初期化）
            ctx.root.$store.commit('setTitleIcon', '');

            // mainTitle変更（初期化）
            ctx.root.$store.commit('setMainTitle', '');

            // メッセージ設定
            state.displayMessage = CommonFunction.replaceArray(MessageConst.E_NOT_FOUND, ['指定されたページ']);
        }

        return {
            state
        }
    }
})
